<span *ngIf="showIcon" title="{{ rowData.AppVersion }}">
  <i *ngIf="value === 'iOS'" class="ion-social-apple"></i>
  <i *ngIf="value === 'Android'" class="ion-social-android"></i>
</span>
<span *ngIf="showText">
  <span *ngIf="rowData.AppVersion"> {{ rowData.AppVersion }}</span>
  <span *ngIf="!rowData.AppVersion"> Unknown</span>
</span>
